import Event from 'base/event'
import Hub from 'base/hub'

import './cookie'
import './url_add_to_bag'

import facebook from './facebook'

// Every initializer should return a function that can be called to execute
// its initialization code (for lack of a better word). This way
// initialization of things is a discrete part of application setup
// (happening in the "initializers" feature in `init.js`) rather than being
// determined by the load order computed by Webpack.
export default function () {
  Hub.sub(Event.App.LOAD, () => {
    //DependentEvents.dependOn('load', function initializersSetup() {
    facebook()
  })
}
